import { Session } from '@/types/session.types';
import { Put } from '../helpers';

export const UpdateSession = async (session: Session): Promise<Session> => {
  return Put({
    path: '/v3/admin/event/session',
    body: { session },
  });
};
